// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Input for a control-function TargetValue write-through to the device
 * @export
 * @interface ControlWriteInput
 */
export interface ControlWriteInput {
    /**
     * Full OPC UA browse path of the control TargetValue
     * @type {string}
     * @memberof ControlWriteInput
     */
    browsePath: string;
    /**
     * The value to write (coerced to the target node's data type)
     * @type {any}
     * @memberof ControlWriteInput
     */
    value: any | null;
}

/**
 * Check if a given object implements the ControlWriteInput interface.
 */
export function instanceOfControlWriteInput(value: object): value is ControlWriteInput {
    if (!('browsePath' in value) || value['browsePath'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ControlWriteInputFromJSON(json: any): ControlWriteInput {
    return ControlWriteInputFromJSONTyped(json, false);
}

export function ControlWriteInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlWriteInput {
    if (json == null) {
        return json;
    }
    return {
        
        'browsePath': json['browsePath'],
        'value': json['value'],
    };
}

export function ControlWriteInputToJSON(json: any): ControlWriteInput {
    return ControlWriteInputToJSONTyped(json, false);
}

export function ControlWriteInputToJSONTyped(value?: ControlWriteInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browsePath': value['browsePath'],
        'value': value['value'],
    };
}

